var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglemeet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_897_601)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_897_601",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 512,
    height: 512
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0H0V512H512V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_897_601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#868E96"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166 106V196H76",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166 106V196H286V258L376 185V136C376 116 366 106 346 106",
    fill: "#FFBA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164 406V316H286V256L376 327V376C376 396 366 406 346 406",
    fill: "#00AC47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M286 256L376 183V329",
    fill: "#00832D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M376 183L418 149C427 142 436 142 436 156V356C436 370 427 370 418 363L376 329",
    fill: "#00AC47"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76 314V376C76 396 86 406 106 406H166V314",
    fill: "#0066DA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76 196H166V316H76",
    fill: "#2684FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_897_601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglemeet);
export default __webpack_public_path__ + "static/media/googlemeet.46c092c844f7382d447b7e8bab92b565.svg";
export { ForwardRef as ReactComponent };